import { combineReducers } from "redux";

import {
  chronicle,
  timelines,
  world,
  event,
  maps,
  markers,
  images,
  calendars,
  scroller,
  markerTemplates,
  markerTypes,
  eventTypes,
} from "./";

export const rootReducer = combineReducers({
  chronicle,
  timelines,
  world,
  event,
  eventTypes,
  maps,
  markers,
  images,
  calendars,
  scroller,
  markerTemplates,
  markerTypes,
});
